import {Stack} from '@primer/react'
import {useCommentsAndReviews} from './data/use-comments-and-reviews'
import {IssueComment} from './issue-comments/IssueComment'
import {ReviewComment} from './review-comments/ReviewComment'
import {SyncCommentData} from './shared/SyncCommentData'
import {OverviewThread} from './thread-comments/OverviewThread'

export function CommentsAndReviews() {
  const commentsAndReviews = useCommentsAndReviews()

  return (
    <>
      <SyncCommentData />
      {commentsAndReviews.length > 0 ? (
        <Stack aria-label="Comments" direction="vertical" gap="normal" as="ul">
          {commentsAndReviews.map(commentOrReview => {
            switch (commentOrReview.type) {
              case 'comment':
                return <IssueComment key={commentOrReview.data.id} comment={commentOrReview.data} />
              case 'review':
                return (
                  <ReviewComment
                    key={commentOrReview.data.summary.id}
                    reviewSummary={commentOrReview.data.summary}
                    threads={commentOrReview.data.threads}
                  />
                )
              case 'thread':
                return <OverviewThread key={commentOrReview.data.id} thread={commentOrReview.data} />
            }
          })}
        </Stack>
      ) : (
        'No comments yet.' // TODO: better empty state with prompt to add comment
      )}
    </>
  )
}
